import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    graph1: { main: string; secondary: string, line: string; };
    graph2: { main: string; secondary: string, line: string; };
    graph3: { main: string; secondary: string, line: string; };
    graph4: { main: string; secondary: string, line: string; };
    graph5: { main: string; secondary: string, line: string; };
  }
  interface PaletteOptions {
    graph1?: { main: string; secondary: string, line: string; };
    graph2?: { main: string; secondary: string, line: string; };
    graph3?: { main: string; secondary: string, line: string; };
    graph4?: { main: string; secondary: string, line: string; };
    graph5?: { main: string; secondary: string, line: string; };
  }
}

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#EB0A1E",
    },
    secondary: {
      main: "#c1c1c1",
    },
    error: {
      main: "#f65041",
      contrastText: "#f65041",
    },
    text: {
      secondary: "#EB0A1E",
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#eb0a1e",
    },
    secondary: {
      main: "#c1c1c1",
    },
    text: {
      secondary: "rgba(0,0,0,0.7)",
      disabled: "rgba(0,0,0,0.4)",
      primary: "rgba(0,0,0,0.87)",
    },
    error: {
      main: "#f65041",
      contrastText: "#f65041",
    },
    background: {
      default: "rgba(255,255,255,0.9)",
    },
    graph1: {
      main: "#4399E3",
      secondary: "#4399E350",
      line: "#eb0a1e"
    },
    graph2: {
      main: "#52C1B4",
      secondary: "#52C1B450",
      line: "#9c27b0"
    },
    graph3: {
      main: "#F12B78",
      secondary: "#F12B7850",
      line: "#d32f2f"
    },
    graph4: {
      main: "#FF5B2D",
      secondary: "#FF5B2D50",
      line: "#2e7d32"
    },
    graph5: {
      main: "#8D1F7D",
      secondary: "#8D1F7D50",
      line: "#1976d2"
    },
  },
});
